import { render, staticRenderFns } from "./TodoItem.vue?vue&type=template&id=7b37f2a7&scoped=true"
import script from "./TodoItem.vue?vue&type=script&lang=js"
export * from "./TodoItem.vue?vue&type=script&lang=js"
import style0 from "./TodoItem.vue?vue&type=style&index=0&id=7b37f2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37f2a7",
  null
  
)

export default component.exports